// import React, { useState } from "react";
// import "./login.css";
// import CustomInput from "../../CustomComponents/CustomInput/CustomInput";
// import CustomButton from "../../CustomComponents/CustomButton/CustomButton";
// import { useNavigate } from "react-router";
// import { GetRoute, PostRoute } from "../../Custom_hooks/Routes";
// import { useDispatch } from "react-redux";
// import { setAuth } from "../../Redux/Store";
// import Swal from "sweetalert2";

// import ClimbingBoxLoader from "react-spinners/ClipLoader";
// import { BackgroundGradientAnimation } from "@/components/ui/background-gradient-animation";

// const Login = () => {
//   const navigate = useNavigate();
//   const [userName, setUserName] = useState("");
//   const [password, setPassword] = useState("");
//   const [name, setName] = useState("");
//   const [loader, setLoader] = useState(false);
//   const dispatch = useDispatch();
//   const [forgotPassword, setForgotPassword] = useState(false);
//   const [OTP, setOTP] = useState("");
//   const [authType, setAuthType] = useState("Login");
//   const [isOTP, setIsOTP] = useState(false);
//   const [isOTPSent, setIsOTPSent] = useState(false);
//   const [error, setError] = useState("");

//   const handleUserNameChange = (ev) => {
//     setUserName(ev.target.value);
//     console.log(ev.target.value);
//   };
//   const handlePasswordChange = (ev) => {
//     setPassword(ev.target.value);
//   };

//   const handleNameChange = (ev) => {
//     setName(ev.target.value);
//   };

//   const handleLogin = () => {
//     if (userName === "" || password === "") {
//       return setError("Please enter login credentials.");
//     }
//     GetRoute(
//       `login/${userName}/${password}`,
//       () => {
//         setLoader(true);
//       },
//       (data) => {
//         if (data.auth === false) {
//           setError("Invalid email or password.");
//         } else {
//           if (data.type === "user") {
//             if (data.data.isApproved === false) {
//               setError("Account not approved by the Admin.");
//             } else {
//               dispatch(setAuth(data));

//               navigate("/user/dashboard");
//             }
//           } else {
//             dispatch(setAuth(data));
//             navigate("/admin/dashboard");
//           }
//         }
//         setLoader(false);
//         console.log("data", data);
//       },
//     );
//   };
//   const handleSignUp = () => {
//     if (userName === "" || password === "" || name === "") {
//       return setError("Some fields are missing.");
//     }
//     const bodyData = {
//       name: name,
//       email: userName,
//       password: password,
//     };
//     PostRoute(
//       "signup",
//       () => {
//         setLoader(true);
//       },
//       (res) => {
//         console.log(res);
//         if (res.status === 200) {
//           setAuthType("Login");
//           Swal.fire({
//             icon: "success",
//             title: "Account Created",
//             text: "Your account is successfully created with eduskillprep. Please login to continue.",
//           });
//         } else if (res.status === 201) {
//           setError("User already exists.");
//         }
//         setLoader(false);
//       },
//       bodyData,
//     );
//   };

//   const handleSendOTP = () => {
//     if (userName === "") {
//       return setError("Please enter your email.");
//     }
//     PostRoute(
//       "sendOTP",
//       () => {
//         setLoader(true);
//       },
//       (res) => {
//         console.log(res);
//         if (res.status === 200) {
//           setIsOTPSent(true);
//           setLoader(false);
//           Swal.fire({
//             icon: "success",
//             title: "OTP Sent",
//             text: "An OTP has been sent to your email address. Please check your inbox and enter the OTP to reset your password. OTP is valid for 24 hours.",
//           });
//           setIsOTP(true);
//         } else {
//           setLoader(false);
//           setError("Error sending OTP.");
//         }
//       },
//       { email: userName },
//     );
//   };

//   const handleVerifyOTP = () => {
//     if (userName === "" || OTP === "") {
//       return setError("Please enter all the fields.");
//     }
//     PostRoute(
//       "verifyOTP",
//       () => {
//         setLoader(true);
//       },
//       (res) => {
//         setLoader(false);
//         if (res.status === 200) {
//           Swal.fire({
//             icon: "success",
//             title: "Password Changed",
//             text: "Your password has been changed successfully.",
//           });
//           setForgotPassword(false);
//           setIsOTP(false);
//           setOTP("");
//           setError("");
//           setAuthType("Login");
//         } else {
//           setError('Error verifying OTP.');
//         }
//       },
//       { email: userName, otp: OTP, newPassword: password },
//     );
//   };

//   return (
//     <>
//       <div className="authContainer">
//         <div className="authStyle">
//           <img
//             onClick={() => {
//               console.log("hello");
//               navigate("/");
//             }}
//             className="backIcon"
//             src="https://img.icons8.com/ios-filled/50/FFFFFF/circled-left-2.png"
//             alt="circled-left-2"
//           />
//         </div>
//         <div className="authFormContainer">
//           <div
//             className="auth"
//             style={{ display: "flex", justifyContent: "space-between" }}
//           >
//             <img
//               src="https://static.vecteezy.com/system/resources/previews/003/689/228/non_2x/online-registration-or-sign-up-login-for-account-on-smartphone-app-user-interface-with-secure-password-mobile-application-for-ui-web-banner-access-cartoon-people-illustration-vector.jpg"
//               alt=""
//               srcset=""
//               className="loginImage"
//               height={350}
//               width={450}
//             />
//             <div className="form">
//               <div className="authHeader" style={{ color: "#4f46e5" }}>
//                 {authType}
//                 {error !== "" && <span className="error">{error}</span>}
//               </div>
//               {authType !== "Login" && !forgotPassword && (
//                 <CustomInput
//                   label={"Name"}
//                   placeholder={"Enter your name"}
//                   type="text"
//                   handleInputChange={handleNameChange}
//                   value={name}
//                   Required={true}
//                 />
//               )}
//               {!forgotPassword && (
//                 <>
//                   <CustomInput
//                     label={" Email "}
//                     placeholder={"Enter your email"}
//                     type="email"
//                     handleInputChange={handleUserNameChange}
//                     value={userName}
//                     Required={true}
//                   />
//                   <CustomInput
//                     label={"Password"}
//                     placeholder={"Enter your password"}
//                     type="password"
//                     handleInputChange={handlePasswordChange}
//                     value={password}
//                     Required={true}
//                   />
//                 </>
//               )}
//               {forgotPassword && (
//                 <>
//                   <CustomInput
//                     label={" Email "}
//                     placeholder={"Enter your email"}
//                     type="email"
//                     handleInputChange={handleUserNameChange}
//                     value={userName}
//                     Required={true}
//                   />
//                   {isOTP && (
//                     <>
//                       <CustomInput
//                         label={"New Password"}
//                         placeholder={"Enter your new password"}
//                         type="password"
//                         handleInputChange={handlePasswordChange}
//                         value={password}
//                         Required={true}
//                       />
//                       <CustomInput
//                         label={"OTP"}
//                         placeholder={"Enter your OTP"}
//                         type="password"
//                         handleInputChange={(ev) => setOTP(ev.target.value)}
//                         value={OTP}
//                         Required={true}
//                       />
//                     </>
//                   )}
//                 </>
//               )}
//               {authType === "Login" && !forgotPassword && (
//                 <div
//                   className="smallText"
//                   onClick={() => {
//                     setForgotPassword(true);
//                     setAuthType("Forgot Password");
//                   }}
//                 >
//                   Forget Password ?
//                 </div>
//               )}
//               {loader ? (
//                 <div
//                   style={{
//                     width: "100%",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     display: "flex",
//                     marginTop: "20px",
//                   }}
//                 >
//                   <ClimbingBoxLoader
//                     color={"rgb(9, 56, 136)"}
//                     loading={loader}
//                     size={30}
//                     aria-label="Loading Spinner"
//                     data-testid="loader"
//                   />
//                 </div>
//               ) : forgotPassword ? (
//                 <CustomButton
//                   text={!isOTPSent ? "Send OTP" : "Verify OTP"}
//                   handleClick={!isOTPSent ? handleSendOTP : handleVerifyOTP}
//                   isDissabled={userName ? false : true}
//                   style={{}}
//                 />
//               ) : (
//                 <CustomButton
//                   text={authType === "Login" ? "Login" : "Sign Up"}
//                   handleClick={
//                     authType === "Login" ? handleLogin : handleSignUp
//                   }
//                   isDissabled={false}
//                   style={{}}
//                 />
//               )}
//               {authType === "Login" ? (
//                 <div
//                   className="alternateOption"
//                   onClick={() => {
//                     setError("");
//                     setAuthType("Sign Up");
//                     setForgotPassword(false);
//                   }}
//                 >
//                   <div> Or don't have an account ? SIGN UP </div>{" "}
//                 </div>
//               ) : (
//                 <div
//                   className="alternateOption"
//                   onClick={() => {
//                     setError("");
//                     setAuthType("Login");
//                     setForgotPassword(false);
//                   }}
//                 >
//                   <div> Already have an account ? LOGIN </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Login;

import React, { useState } from "react";
import "./login.css";
import CustomInput from "../../CustomComponents/CustomInput/CustomInput";
import CustomButton from "../../CustomComponents/CustomButton/CustomButton";
import { useNavigate } from "react-router";
import { GetRoute, PostRoute } from "../../Custom_hooks/Routes";
import { useDispatch } from "react-redux";
import { setAuth } from "../../Redux/Store";
import Swal from "sweetalert2";
const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [loader, setLoader] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [OTP, setOTP] = useState("");
  const [authType, setAuthType] = useState("Login");
  const [isOTP, setIsOTP] = useState(false);
  const [isOTPSent, setIsOTPSent] = useState(false);
  const [error, setError] = useState("");
  const [errorKey, setErrorKey] = useState(0);
  /* * ========================================== * ERROR HANDLER * ========================================== * * The important part here is errorKey. * * Even if the same error appears twice: * * "Invalid email or password." * "Invalid email or password." * * React gets a new key and remounts the error * element, causing the animation to play again. */ const showError =
    (message) => {
      setError("");
      requestAnimationFrame(() => {
        setErrorKey((prev) => prev + 1);
        setError(message);
      });
    };
  const clearError = () => {
    setError("");
  };
  /* * ========================================== * INPUT HANDLERS * ========================================== */ const handleUserNameChange =
    (ev) => {
      setUserName(ev.target.value);
      clearError();
    };
  const handlePasswordChange = (ev) => {
    setPassword(ev.target.value);
    clearError();
  };
  const handleNameChange = (ev) => {
    setName(ev.target.value);
    clearError();
  };
  const handleOTPChange = (ev) => {
    setOTP(ev.target.value);
    clearError();
  };
  /* * ========================================== * LOGIN * ========================================== */ const handleLogin =
    () => {
      if (loader) return;
      clearError();
      if (userName === "" || password === "") {
        return showError("Please enter login credentials.");
      }
      GetRoute(
        `login/${userName}/${password}`,
        () => {
          setLoader(true);
        },
        (data) => {
          if (data.auth === false) {
            showError("Invalid email or password.");
            setLoader(false);
            return;
          }
          if (data.type === "user") {
            if (data.data.isApproved === false) {
              showError("Account not approved by the Admin.");
              setLoader(false);
              return;
            }
            dispatch(setAuth(data));
            setLoader(false);
            navigate("/user/dashboard");
            return;
          }
          dispatch(setAuth(data));
          setLoader(false);
          navigate("/admin/dashboard");
        },
      );
    };
  /* * ========================================== * SIGN UP * ========================================== */ const handleSignUp =
    () => {
      if (loader) return;
      clearError();
      if (userName === "" || password === "" || name === "") {
        return showError("Some fields are missing.");
      }
      const bodyData = { name: name, email: userName, password: password };
      PostRoute(
        "signup",
        () => {
          setLoader(true);
        },
        (res) => {
          if (res.status === 200) {
            setLoader(false);
            setAuthType("Login");
            Swal.fire({
              icon: "success",
              title: "Account Created",
              text: "Your account is successfully created with eduskillprep. Please login to continue.",
            });
            return;
          }
          if (res.status === 201) {
            showError("User already exists.");
          } else {
            showError("Unable to create your account. Please try again.");
          }
          setLoader(false);
        },
        bodyData,
      );
    };
  /* * ========================================== * SEND OTP * ========================================== */ const handleSendOTP =
    () => {
      if (loader) return;
      clearError();
      if (userName === "") {
        return showError("Please enter your email.");
      }
      PostRoute(
        "sendOTP",
        () => {
          setLoader(true);
        },
        (res) => {
          if (res.status === 200) {
            setLoader(false);
            setIsOTPSent(true);
            setIsOTP(true);
            Swal.fire({
              icon: "success",
              title: "OTP Sent",
              text: "An OTP has been sent to your email address. Please check your inbox and enter the OTP to reset your password. OTP is valid for 24 hours.",
            });
            return;
          }
          setLoader(false);
          showError("Error sending OTP.");
        },
        { email: userName },
      );
    };
  /* * ========================================== * VERIFY OTP / RESET PASSWORD * ========================================== */ const handleVerifyOTP =
    () => {
      if (loader) return;
      clearError();
      if (userName === "" || OTP === "" || password === "") {
        return showError("Please enter all the fields.");
      }
      PostRoute(
        "verifyOTP",
        () => {
          setLoader(true);
        },
        (res) => {
          setLoader(false);
          if (res.status === 200) {
            Swal.fire({
              icon: "success",
              title: "Password Changed",
              text: "Your password has been changed successfully.",
            });
            setForgotPassword(false);
            setIsOTP(false);
            setIsOTPSent(false);
            setOTP("");
            setPassword("");
            setError("");
            setAuthType("Login");
            return;
          }
          showError("Error verifying OTP.");
        },
        { email: userName, otp: OTP, newPassword: password },
      );
    };
  /* * ========================================== * RESET AUTH STATE * ========================================== */ const resetAuthState =
    () => {
      clearError();
      setForgotPassword(false);
      setIsOTP(false);
      setIsOTPSent(false);
      setOTP("");
      setPassword("");
    };
  /* * ========================================== * SWITCH TO SIGNUP * ========================================== */ const switchToSignup =
    () => {
      if (loader) return;
      resetAuthState();
      setAuthType("Sign Up");
    };
  /* * ========================================== * SWITCH TO LOGIN * ========================================== */ const switchToLogin =
    () => {
      if (loader) return;
      resetAuthState();
      setAuthType("Login");
    };
  /* * ========================================== * SWITCH TO FORGOT PASSWORD * ========================================== */ const switchToForgotPassword =
    () => {
      if (loader) return;
      clearError();
      setForgotPassword(true);
      setIsOTP(false);
      setIsOTPSent(false);
      setOTP("");
      setPassword("");
      setAuthType("Forgot Password");
    };
  /* * ========================================== * HEADING * ========================================== */ const getHeading =
    () => {
      if (forgotPassword) {
        return isOTP ? "Create a new password" : "Reset your password";
      }
      if (authType === "Sign Up") {
        return "Create your account";
      }
      return "Welcome back";
    };
  /* * ========================================== * SUBTITLE * ========================================== */ const getSubtitle =
    () => {
      if (forgotPassword) {
        return isOTP
          ? "Enter the OTP and your new password to continue."
          : "Enter your email and we'll send you a verification code.";
      }
      if (authType === "Sign Up") {
        return "Create an account to get started with Eduskillprep.";
      }
      return "Sign in to continue to your Eduskillprep account.";
    };
  /* * ========================================== * BUTTON TEXT * ========================================== */ const getButtonText =
    () => {
      if (forgotPassword) {
        return isOTPSent ? "Verify OTP" : "Send OTP";
      }
      return authType === "Login" ? "Login" : "Sign Up";
    };
  /* * ========================================== * LOADER TEXT * ========================================== */ const getLoaderText =
    () => {
      if (forgotPassword) {
        return isOTPSent ? "Verifying OTP..." : "Sending OTP...";
      }
      return authType === "Login" ? "Signing in..." : "Creating account...";
    };
  /* * ========================================== * BUTTON HANDLER * ========================================== */ const handleSubmit =
    () => {
      if (loader) return;
      if (forgotPassword) {
        if (isOTPSent) {
          handleVerifyOTP();
        } else {
          handleSendOTP();
        }
        return;
      }
      if (authType === "Login") {
        handleLogin();
      } else {
        handleSignUp();
      }
    };
  return (
    <div className="loginPage">
      {" "}
      {/* ====================================== BACKGROUND ====================================== */}{" "}
      <div className="authGlow authGlowOne" />{" "}
      <div className="authGlow authGlowTwo" />{" "}
      {/* ====================================== BACK BUTTON ====================================== */}{" "}
      <button
        className="backButton"
        onClick={() => {
          if (!loader) {
            navigate("/");
          }
        }}
        disabled={loader}
        aria-label="Go back"
      >
        {" "}
        <span>←</span> <span>Back to home</span>{" "}
      </button>{" "}
      <div className="authCard">
        {" "}
        {/* ==================================== LEFT VISUAL SECTION ==================================== */}{" "}
        <div className="authVisual">
          {" "}
          <div className="visualOverlay" />{" "}
          <div className="visualContent">
            {" "}
            <div className="brandBadge">
              {" "}
              <span className="brandDot" /> Eduskillprep{" "}
            </div>{" "}
            <div className="visualText">
              {" "}
              <span className="eyebrow"> LEARN • GROW • ACHIEVE </span>{" "}
              <h1>
                {" "}
                Your journey to <span> better learning </span> starts here.{" "}
              </h1>{" "}
              <p>
                {" "}
                Access your learning dashboard, track your progress and continue
                building your future.{" "}
              </p>{" "}
            </div>{" "}
            <div className="visualStats">
              {" "}
              <div className="statItem">
                {" "}
                <strong>01</strong> <span>Learn smarter</span>{" "}
              </div>{" "}
              <div className="statDivider" />{" "}
              <div className="statItem">
                {" "}
                <strong>02</strong> <span>Track progress</span>{" "}
              </div>{" "}
              <div className="statDivider" />{" "}
              <div className="statItem">
                {" "}
                <strong>03</strong> <span>Achieve more</span>{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
          <div className="floatingShape shapeOne" />{" "}
          <div className="floatingShape shapeTwo" />{" "}
        </div>{" "}
        {/* ==================================== FORM SECTION ==================================== */}{" "}
        <div className="authFormContainer">
          {" "}
          <div className="formHeaderMobile">
            {" "}
            <div className="mobileBrand">
              {" "}
              <span className="brandDot" />
            </div>{" "}
          </div>{" "}
          <div className="formWrapper">
            {" "}
            {/* ================================= FORM HEADER ================================= */}{" "}
            <div className="formTop">
              {" "}
              <span className="formLabel">
                {" "}
                {forgotPassword
                  ? "ACCOUNT RECOVERY"
                  : authType === "Sign Up"
                    ? "GET STARTED"
                    : "WELCOME BACK"}{" "}
              </span>{" "}
              <h2> {getHeading()} </h2> <p> {getSubtitle()} </p>{" "}
            </div>{" "}
            {/* ================================= ANIMATED ERROR ================================= */}{" "}
            {error !== "" && (
              <div key={errorKey} className="errorBox errorBoxAnimate">
                {" "}
                <div className="errorIcon"> ! </div>{" "}
                <span className="errorMessage"> {error} </span>{" "}
              </div>
            )}{" "}
            {/* ================================= FORM ================================= */}{" "}
            <div className="form">
              {" "}
              {/* SIGNUP NAME */}{" "}
              {authType !== "Login" && !forgotPassword && (
                <div className="inputGroup inputAnimated">
                  {" "}
                  <CustomInput
                    label={"Name"}
                    placeholder={"Enter your name"}
                    type="text"
                    handleInputChange={handleNameChange}
                    value={name}
                    Required={true}
                  />{" "}
                </div>
              )}{" "}
              {/* LOGIN / SIGNUP */}{" "}
              {!forgotPassword && (
                <>
                  {" "}
                  <div className="inputGroup inputAnimated delay1">
                    {" "}
                    <CustomInput
                      label={"Email"}
                      placeholder={"Enter your email"}
                      type="email"
                      handleInputChange={handleUserNameChange}
                      value={userName}
                      Required={true}
                    />{" "}
                  </div>{" "}
                  <div className="inputGroup inputAnimated delay2">
                    {" "}
                    <CustomInput
                      label={"Password"}
                      placeholder={"Enter your password"}
                      type="password"
                      handleInputChange={handlePasswordChange}
                      value={password}
                      Required={true}
                    />{" "}
                  </div>{" "}
                </>
              )}{" "}
              {/* ================================= FORGOT PASSWORD ================================= */}{" "}
              {forgotPassword && (
                <>
                  {" "}
                  <div className="inputGroup inputAnimated delay1">
                    {" "}
                    <CustomInput
                      label={"Email"}
                      placeholder={"Enter your email"}
                      type="email"
                      handleInputChange={handleUserNameChange}
                      value={userName}
                      Required={true}
                    />{" "}
                  </div>{" "}
                  {isOTP && (
                    <>
                      {" "}
                      <div className="inputGroup inputAnimated delay2">
                        {" "}
                        <CustomInput
                          label={"New Password"}
                          placeholder={"Enter your new password"}
                          type="password"
                          handleInputChange={handlePasswordChange}
                          value={password}
                          Required={true}
                        />{" "}
                      </div>{" "}
                      <div className="inputGroup inputAnimated delay3">
                        {" "}
                        <CustomInput
                          label={"OTP"}
                          placeholder={"Enter your OTP"}
                          type="password"
                          handleInputChange={handleOTPChange}
                          value={OTP}
                          Required={true}
                        />{" "}
                      </div>{" "}
                    </>
                  )}{" "}
                </>
              )}{" "}
              {/* ================================= FORGOT PASSWORD LINK ================================= */}{" "}
              {authType === "Login" && !forgotPassword && (
                <div className="forgotLink" onClick={switchToForgotPassword}>
                  {" "}
                  Forgot password?{" "}
                </div>
              )}{" "}
              {/* ================================= BUTTON + LOADER ================================= */}{" "}
              <div className="actionArea">
                {" "}
                <button
                  type="button"
                  className={`authSubmitButton ${loader ? "buttonLoading" : ""}`}
                  onClick={handleSubmit}
                  disabled={loader}
                >
                  {" "}
                  {loader ? (
                    <span className="buttonLoaderContent">
                      {" "}
                      <span className="buttonSpinner" />{" "}
                      <span className="buttonLoadingText">
                        {" "}
                        {getLoaderText()}{" "}
                      </span>{" "}
                    </span>
                  ) : (
                    <span className="buttonText"> {getButtonText()} </span>
                  )}{" "}
                </button>{" "}
              </div>{" "}
              {/* ================================= AUTH SWITCH ================================= */}{" "}
              <div className="authSwitch">
                {" "}
                {forgotPassword ? (
                  <>
                    {" "}
                    <span> Remember your password? </span>{" "}
                    <button
                      type="button"
                      onClick={switchToLogin}
                      disabled={loader}
                    >
                      {" "}
                      Back to Login{" "}
                    </button>{" "}
                  </>
                ) : authType === "Login" ? (
                  <>
                    {" "}
                    <span> Don't have an account? </span>{" "}
                    <button
                      type="button"
                      onClick={switchToSignup}
                      disabled={loader}
                    >
                      {" "}
                      Create account{" "}
                    </button>{" "}
                  </>
                ) : (
                  <>
                    {" "}
                    <span> Already have an account? </span>{" "}
                    <button
                      type="button"
                      onClick={switchToLogin}
                      disabled={loader}
                    >
                      {" "}
                      Login{" "}
                    </button>{" "}
                  </>
                )}{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
          {/* ================================= FOOTER ================================= */}{" "}
          <div className="formFooter">
            {" "}
            <span> © {new Date().getFullYear()} Eduskillprep </span>{" "}
            <span> Secure &amp; private </span>{" "}
          </div>{" "}
        </div>{" "}
      </div>{" "}
    </div>
  );
};
export default Login;
